import { defineWave } from '../schema';

/** BLOC C — la PRESSION VERTICALE. Densité maximale du niveau.
 *
 *  Trois Faucheurs postés simultanément, plus du popcorn qui descend entre
 *  eux. Le terrain se réduit par le haut, et le joueur doit descendre — mais
 *  descendre réduit son temps de réaction sur les tirs visés.
 *
 *  On règle l'intensité de ce bloc en changeant le NOMBRE de Faucheurs, jamais
 *  leurs statistiques (voir faucheur.def.ts). C'est ce qui permet de calibrer un
 *  niveau sans invalider l'intuition construite sur tous les autres. */
export default defineWave({
  id: 'c1-pression',
  duration: 18,
  spawns: [
    { at: 0.0, enemy: 'faucheur', lane: 2, count: 1, spacing: 0 },
    { at: 0.4, enemy: 'faucheur', lane: 4, count: 1, spacing: 0 },
    { at: 2.5, enemy: 'mite', lane: 3, count: 8, spacing: 0.07 },
    { at: 4.0, enemy: 'rodeur', lane: 1, count: 1, spacing: 0 },
    { at: 6.0, enemy: 'faucheur', lane: 3, count: 1, spacing: 0 },
    { at: 7.5, enemy: 'eclat', lane: 1, count: 2, spacing: 0.5 },
    { at: 7.9, enemy: 'eclat', lane: 5, count: 2, spacing: 0.5 },
    { at: 10.5, enemy: 'rodeur', lane: 5, count: 1, spacing: 0 },
    { at: 12.0, enemy: 'mite', lane: 2, count: 7, spacing: 0.06 },
    { at: 12.4, enemy: 'mite', lane: 4, count: 7, spacing: 0.06 },
    { at: 15.0, enemy: 'faucheur', lane: 3, count: 1, spacing: 0 },
  ],
});
